export const useMaska = () => {
    const unmaskNumbers = (masked_value: string): string => {
        const unmasked_value = masked_value.replace(/[^\d]/g, '')
        return unmasked_value
    }

    const maskNumberToPrice = (amount: number | string): string => {
        return amount.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1 ') + ' ₸'
    }

    const numberWithSpaces = (amount: number | string): string => {
        return amount.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1 ')
    }

    return { unmaskNumbers, maskNumberToPrice, numberWithSpaces }
}
